<template>
  <button @click="generatePDF">
      <slot>Generate PDF</slot>
  </button>
</template>

<script>
import { jsPDF } from 'jspdf';

export default {
  name: 'GeneratePDF',
  props: {
      card: {
          type: Object,
          required: true,
      },
  },
  methods: {
      generatePDF() {
          if (!this.card) {
              console.error("Error: No misconduct card data available.");
              return;
          }

          const doc = new jsPDF();
          const margin = 10;

          /* Set Font */
          doc.setFont("helvetica", "normal");
          doc.setFontSize(12);

          /* Header */
          doc.text("SUPPLEMENTAL REPORT", 105, 10, { align: "center" });

          /* Game Information */
          doc.text("Date:", margin, 15);
          doc.text(this.formatDate(this.card.GameDate), margin, 23);

          doc.text("Game #:", 35, 15);
          doc.text(`${this.card.GameNumber || "N/A"}`, 35, 23);

          doc.text("Teams", 80, 15);
          doc.text("(home)", 65, 23);
          doc.text(`${this.card.TeamHome || "N/A"}`, 80, 23);
          doc.text("(away)", 65, 30);
          doc.text(`${this.card.TeamAway || "N/A"}`, 80, 30);

          doc.text("Final Score", 133, 15);
          doc.text(`${this.card.ScoreHome || "N/A"} - ${this.card.ScoreAway || "N/A"}`, 133, 23);

          doc.text(`Match Level: ${this.card.GenderAge || "N/A"}`, margin, 40);
          doc.text(`League: ${this.card.LeagueTypeSeason || "N/A"}`, margin + 40, 40);

          doc.text(`REF: ${this.card.REFName || "N/A"}`, margin + 5, 55);
          doc.text(`AR1: ${this.card.AR1Name || "N/A"}`, margin + 5, 62);
          doc.text(`AR2: ${this.card.AR2Name || "N/A"}`, margin + 5, 69);
          doc.text(`4th REF: ${this.card.REF4thName || "N/A"}`, margin + 5, 76);

          doc.text("Misconduct Totals", margin + 152, 15);
          doc.text(`Yellow Cards: ${this.card.YellowCardCount || "0"}`, margin + 155, 23);
          doc.text(`Red Cards: ${this.card.RedCardCount || "0"}`, margin + 155, 30);

          doc.setLineWidth(1);
          doc.line(margin, 86, 200, 86);

          /* Misconduct Information */
          doc.text("Time:", margin, 95);
          doc.text(`${this.card.Time || "N/A"}`, margin + 10, 95);

          doc.text("Offender:", margin + 25, 95);
          doc.text(`${this.card.Offender || "N/A"}`, margin + 45, 95);

          doc.text("Team:", margin + 80, 95);
          doc.text(`${this.card.Team || "N/A"}`, margin + 100, 95);

          doc.text("Player (#, Last, First):", margin, 110);
          doc.text(`#${this.card.PlayerNumber || "N/A"} -- ${this.card.PlayerNameLast || "N/A"}, ${this.card.PlayerNameFirst || "N/A"}`, margin + 60, 110);

          doc.text("Incident Type:", margin, 125);
          doc.text(`${this.card.IncidentType || "N/A"}`, margin + 35, 125);

          doc.text("Misconduct:", margin, 135);
          doc.text(`${this.card.MisconductItem || "N/A"}`, margin + 35, 135);

          doc.text("Referee Action:", margin, 145);
          doc.text(`${this.card.RefereeAction || "N/A"}`, margin + 35, 145);

          doc.text("Description:", margin, 155);
          const incidentDescription = doc.splitTextToSize(this.card.IncidentDescription || "N/A", 150);
          doc.text(incidentDescription, margin + 35, 155);

          /* Generate File Name */
          const fileName = `${this.formatDateForFile(this.card.GameDate)}_Supplemental_Report_Game#${this.card.GameNumber || "N/A"}_${this.card.Time || "N/A"}min_${this.card.MisconductCode || "N/A"}.pdf`;

          /* Save the PDF */
          doc.save(fileName);
      },

      // ✅ Helper function to format the date as MM/DD/YYYY
      formatDate(date) {
          if (!date) return "N/A";

          let d;
          if (date instanceof Object && typeof date.toDate === "function") {
              d = date.toDate();
          } else if (typeof date === "string") {
              d = new Date(date);
          } else {
              d = new Date(date.seconds * 1000);
          }

          const month = (d.getMonth() + 1).toString().padStart(2, '0');
          const day = d.getDate().toString().padStart(2, '0');
          const year = d.getFullYear().toString().slice(-2);
          return `${month}/${day}/${year}`;
      },

      // ✅ Helper function to format the date as YYYYMMDD for filename
      formatDateForFile(date) {
          if (!date) return "N/A";

          let d;
          if (date instanceof Object && typeof date.toDate === "function") {
              d = date.toDate();
          } else if (typeof date === "string") {
              d = new Date(date);
          } else {
              d = new Date(date.seconds * 1000);
          }

          const year = d.getFullYear();
          const month = (d.getMonth() + 1).toString().padStart(2, '0');
          const day = d.getDate().toString().padStart(2, '0');
          return `${year}${month}${day}`;
      },
  },
};
</script>

<style scoped>
button {
  cursor: pointer;
  font-size: 14px;
  padding: 8px 12px;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
}

button:hover {
  background-color: #0056b3;
}
</style>
